import React, { createContext, useState, useEffect } from 'react';

const QueryParamsContext = createContext();

export const QueryParamsProvider = ({ children }) => {
    const [parameters, setParameters] = useState(() => {
        const storedParams = localStorage.getItem('queryParams');
        return storedParams ? JSON.parse(storedParams) : {};
    });
    useEffect(() => {
        localStorage.setItem('queryParams', JSON.stringify(parameters));
    }, [parameters]);

    return (
        <QueryParamsContext.Provider value={{ parameters, setParameters }}>
            {children}
        </QueryParamsContext.Provider>
    );
};
 
export default QueryParamsContext;